import AlternativeImage from './AlternativeImage';

export default AlternativeImage;
